module.exports = __webpack_public_path__ + "static/media/gym-sauna-bg.d990dc40.png";